import React, { useRef, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import _ from "lodash";
import BlockUi from 'react-block-ui';
import ReduxBlockUi from "react-block-ui/redux";
import "react-block-ui/style.css";
import MessageBox from "../../../components/ui/MessageBox";
import { TouchableOpacity } from "react-native";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Container,
    Row,
    Col,
    Button,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    Progress,
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import { StickyContainer } from "react-sticky";
import * as Helper from "../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/bookgroup/AddMyUnitRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";
import { ImageField } from "../unit/fields/types";
import SimpleUnitForm from "../unit/forms/SimpleUnitForm";
import ReadingDialogField from "../unit/fields/types/ReadingDialogField";
import UnitService from "../../../services/screens/admin/unit/forms/UnitService";
import { CloseOutlined } from "@ant-design/icons";

const uid = UIDs.screens.admin.bookgroup.addmyunit;

class AddMyUnitScreen extends AuthorizedScreen {

    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_UNIT_ASYNC]: { done: this._handleSaveUnitAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        const { id, sectionId, index, show, unitType } = this.props;
        let partnerId = this.props.partner ? this.props.partner.id : null;
        this.props.loadScreenViewAsync({id, sectionId, index, partnerId, show, unitType});
    }

    render() {

        if(this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)){
            return (
                <LoadingIndicator />
            )
        }
        const { order, unit, resourceId, showModal } = this.props.localState;
        return (
            <Row>
                <Col>
                    {showModal ?
                        <KindForm
                            {...this.props}
                            onSaveKind={this._handleSaveKind}
                            onCancel = {this._handleUnitKindCancel}
                        />
                    :
                        <Card className="shadow">
                        <StickyContainer style={{ width: "100%" }}>
                            <ReduxBlockUi tag="div" block={[ActionTypes.LOAD_SCREEN_VIEW_ASYNC, ActionTypes.SAVE_UNIT_ASYNC]}
                                unblock={[ActionTypes.LOAD_SCREEN_VIEW_SUCCESS, ActionTypes.LOAD_SCREEN_VIEW_FAILURE, ActionTypes.SAVE_UNIT_SUCCESS, ActionTypes.SAVE_UNIT_FAILURE]}>
                                    <SimpleUnitForm
                                        key={`unitForm-${unit.id}`}
                                        t={this.props.t}
                                        data={{ unitType: unit.unitType, formData: unit.data, commonFieldValues: { title: unit.data.title}, id: unit.id }}
                                        resourceId={resourceId}
                                        onSave={this._handleSaveUnit}
                                        onCancel={this._handleCreteUnitCancel}
                                    />
                            </ReduxBlockUi>
                        </StickyContainer>
                        </Card>
                    }
                </Col>
                {this.isActionExecuting(ActionTypes.SAVE_UNIT_ASYNC) ?
                 (<div style={{zIndex: 1, position: 'absolute',
                               left: 0, top: 0, right: 0, bottom: 0}}>
                      <LoadingIndicator />
                  </div>) : null}
            </Row>
        );
    }

    _handleCancelDetails = () => {
        const { fromScreen } = this.localVars.navParams;
        if (fromScreen) {
            NavigationService.navigateToPageByUID(this, fromScreen);
        } else{
            NavigationService.navigateToPage(this, `/admin/bookgroup/list`);
        }
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }

    _handleSaveKind = (data) => {
        this.props.onHideContent && this.props.onHideContent();
        this.props.setUnitKind(data.kind);
    };

    _handleSaveUnit  = (formData) => {
        const courseId = this.props.courseId;
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        const { unit, resourceId } = this.props.localState;
                        const { id, unitType, ownerType, ownerId, data } = unit;
                        let vo = { id, unitType, ownerType, courseId, ownerId, resourceId, dataType: formData.dataType, data: JSON.stringify({ ...data, ...formData.data }) };
                        this.props.saveUnit(vo);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    };

    _handleCreteUnitCancel = () => {
        confirmAlert({
            title: this.props.t("confirmToCancel"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this._handleUnitKindCancel();
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleUnitKindCancel = () =>{
        this.props.onHideModal && this.props.onHideModal();
        this.props.onShowContent && this.props.onShowContent();
    }

    _handleSaveUnitAsyncDone = (data) => {
        const backData = data.data;
        const unitId = data.vo.id;
        this.props.onSubmitEnd && this.props.onSubmitEnd(backData, unitId);
    }
}


function KindForm(props) {
    const submitKindRef = useRef();

    const { register, handleSubmit, errors, clearError } = useForm();

    const [modal, setModal] = useState(props.show);

    let kind = "0";
    const [unitKind, setUnitKind] = useState(kind);

    const toggle = () => {
        setModal(!modal);
    }

    const submitForm = (data) => {
        props.onSaveKind(data);
        toggle();
    }

    const cancelSubmit = () => {
        setModal(!modal);
        props.onCancel();
    }

    return (
        <form onSubmit={handleSubmit(submitForm)}>
            <Modal isOpen={modal} style={{width: 600, minWidth: 600, maxWidth: 600, marginTop:"40px"}}>
                <CardHeader className="bg-white border-1">
                    <Row className="align-items-center">
                        <Col style={{textAlign:"center"}}>
                            <span style={{fontSize:24, fontWeight:"500", width:"100%"}}>{props.t("header")}</span>
                            <div style={{position: 'absolute', top: 5, right: 10, cursor: 'pointer'}} onClick={() => {
                                     cancelSubmit();
                                 }}>
                                <CloseOutlined style={{fontSize: 24}} />
                            </div>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col style={{marginLeft:20}}>
                            <TouchableOpacity onPress={()=>{setUnitKind("0")}} style={{float:"left", marginRight:20}}>
                                <div><input type="radio" ref={register} name="kind" checked={unitKind === "0"} value="0" />&nbsp;{props.t("photo")}</div>
                            </TouchableOpacity>
                            <TouchableOpacity onPress={()=>{setUnitKind("1")}} style={{float:"left", marginRight:20}}>
                                <div><input type="radio" ref={register} name="kind" checked={unitKind === "1"} value="1" />&nbsp;{props.t("audio")}</div>
                            </TouchableOpacity>
                            <TouchableOpacity onPress={()=>{setUnitKind("2")}} style={{float:"left"}}>
                                <div><input type="radio" ref={register} name="kind" checked={unitKind === "2"} value="2" />&nbsp;{props.t("reading")}</div>
                            </TouchableOpacity>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{marginTop:20, marginLeft:20}}>
                            <div style={{padding:"20px", borderRadius:"10px", backgroundColor:"#F5F9FF", }}>
                            {
                                unitKind === "0" ?
                                    <>
                                        <div style={{marginBottom: 20}}>{props.t("photoKind")}</div>
                                        <img height="200px" style={{borderRadius:2}} className="teacherImg" src={require("../../../images/screens/admin/bookgroup/photo.png")} alt=""></img>
                                    </>
                                : unitKind === "1" ?
                                    <>
                                        <div style={{marginBottom: 20}}>{props.t("audioKind")}</div>
                                        <div style={{backgroundColor:"#fff", width:"200px", height:"200px", borderRadius: 2, textAlign:"center"}}>
                                            <img style={{width:"200px", padding:"10px", borderRadius:2}} className="teacherImg" src={require("../../../images/screens/admin/bookgroup/audio.png?a=1")} alt=""></img>
                                        </div>
                                    </>
                                :
                                    <>
                                        <div style={{marginBottom: 20}}>{props.t("readingKind")}</div>
                                        <img height="200px" style={{borderRadius:2}} className="teacherImg" src={require("../../../images/screens/admin/bookgroup/reading.png")} alt=""></img>
                                    </>
                            }
                            </div>
                        </Col>
                    </Row>
                </CardBody>
                <CardFooter>
                    <div style={{textAlign:"center"}}>
                        <Button color="primary" disabled={props.isDisabled} onClick={() => {submitKindRef.current.click()}} >
                            {props.t("yes")}
                        </Button>
                        <Button style={{backgroundColor:"#fff", border:"1px solid #4e93e9", color:"#4e93e9"}} disabled={props.isDisabled} onClick={() => cancelSubmit()} >
                            {props.t("cancel")}
                        </Button>
                    </div>
                </CardFooter>
            </Modal>
            <input ref={submitKindRef} type="submit" hidden />
        </form>
    );
};

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partner: state.session.partner,
        user: state.session.user,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: vo => dispatch(Actions.loadScreenViewAsync(vo)),
        saveUnit: vo => dispatch(Actions.saveUnitAsync(vo)),
        showModal: val => dispatch(Actions.showModal(val)),
        setUnitKind: val => dispatch(Actions.setUnitKind(val)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(AddMyUnitScreen));
